import { render, staticRenderFns } from "./InterBanks.vue?vue&type=template&id=a6311b3e&scoped=true&lang=pug"
import script from "./InterBanks.vue?vue&type=script&lang=js"
export * from "./InterBanks.vue?vue&type=script&lang=js"
import style0 from "./InterBanks.vue?vue&type=style&index=0&id=a6311b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6311b3e",
  null
  
)

export default component.exports